import config from '../config';

import axios from "axios";
import mainConfig from "/config";

const endpoint = mainConfig.endpoint + config.name

export default {
    getAllRooms(token, currentPage, perPage) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": token
            }
        };

        let aFormData = new FormData();
        aFormData.append("methods", '__get_my_units__');
        aFormData.append("perPage", perPage);
        aFormData.append("currentPage", currentPage);

        return new Promise((resolve, reject) => {
            axios
                .post(endpoint, aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    getRoomByUID(uid, token) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": token
            }
        };

        let aFormData = new FormData();
        aFormData.append("methods", '__get_unit_by_uid__');
        aFormData.append("uid", uid);

        return new Promise((resolve, reject) => {
            axios
                .post(endpoint, aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    deleteRoomByUID(uid, token) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": token
            }
        };

        const url = endpoint + '?methods=__delete_unit_by_uid__&uid=' + uid;
        return new Promise((resolve, reject) => {
            axios
                .delete(url, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    deleteMessageByUID(uid, token) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": token
            }
        };

        const url = endpoint + '?methods=__delete_msg_by_uid__&uid=' + uid;
        return new Promise((resolve, reject) => {
            axios
                .delete(url, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    setRoom(data, token) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": token
            }
        };

        let aFormData = new FormData();
        aFormData.append("methods", '__create_unit__');
        aFormData.append("data", JSON.stringify(data));

        return new Promise((resolve, reject) => {
            axios
                .post(endpoint, aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },
    /*******************************
     *    Messages
     *******************************/
    setMessage(data, token) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": token
            }
        };

        let aFormData = new FormData();
        aFormData.append("methods", '__create_message__');
        aFormData.append("data", JSON.stringify(data));

        return new Promise((resolve, reject) => {
            axios
                .post(endpoint, aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },


    // ********************************* //
    // Public Requests
    // ********************************* //
    getRooms(filter, currentPage, perPage) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        };

        const url = endpoint + '?methods=__get_units__&filter=' + filter + '&currentPage=' + currentPage + '&perPage=' + perPage;


        return new Promise((resolve, reject) => {
            axios
                .get(url, config)
                .then(resp => {

                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    getRoom(uid, token) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": token
            }
        };

        const url = endpoint + '?methods=__get_unit__&uid=' + uid;

        return new Promise((resolve, reject) => {
            axios
                .get(url, config)
                .then(resp => {

                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    getSearchUnits(filter, currentPage, perPage, name) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                // "Authorization": token
            }
        };

        const url = endpoint + '?methods=__get_search_units__&filter=' + filter + '&currentPage=' + currentPage + '&perPage=' + perPage + '&name=' + name;

        return new Promise((resolve, reject) => {
            axios
                .get(url, config)
                .then(resp => {

                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

}